import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Button from '@cld/button';
import { Icon } from '@cld/icon';
import { isLastView, getActiveViewIdx, getIsNextStepEnable } from 'selectors/views';
import { prevView, nextView } from 'actions/views';
import { messages } from '../../../i18n';
import ExportButton from './ExportButton';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`;

const FooterWizard = ({ isLastStep, activeViewIdx, nextView, prevView, isNextStepEnable }) => (
  <Wrapper>
    {activeViewIdx > 0 ? (
      <Button data-test-specifier="transformation-widget-arrowBackButton" variant="secondary" onClick={prevView}>
        <Icon name="arrowBack" />
        <FormattedMessage {...messages['wizard.footer.back']} />
      </Button>
    ) : (
      <div />
    )}

    {isLastStep ? (
      <ExportButton isDisabled={!isNextStepEnable} />
    ) : (
      <Button data-test-specifier="next" onClick={nextView} disabled={!isNextStepEnable}>
        <FormattedMessage {...messages['wizard.footer.next']} />
        <Icon name="arrowRight" />
      </Button>
    )}
  </Wrapper>
);

const mapDispatchToProps = { prevView, nextView };

const mapStateToProps = (state) => ({
  isLastStep: isLastView(state),
  activeViewIdx: getActiveViewIdx(state),
  isNextStepEnable: getIsNextStepEnable(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(FooterWizard);
